<template>
    <el-form-item 
        :label="itemObj.label" 
        class="add-other-info-item-wrap"
        :prop="itemObj.property_id+''"
        v-show="!itemObj.isDisabled"
    >

    <!-- v-show="!itemObj.isDisabled" 隐藏默认项 -->
        
        <!-- 单选 -->
        <div v-if="nowType == 'select'">
            <el-select 
                v-model="itemVal"
                @input="onInputFn"
                :disabled="itemObj.isDisabled"
                style="width: 240px;" 
                placeholder="请选择"
            >
                <el-option
                    v-for="item in itemObj.options"
                    :key="'single'+item.value"
                    :label="item.name"
                    :value="item.value">
                </el-option>
            </el-select>
        </div>
        
        <!-- 多选 -->
        <div v-else-if="nowType == 'multi_select'">
            <el-select 
                v-model="itemVal"
                @input="onInputFn"
                :disabled="itemObj.isDisabled"
                style="width: 240px;" 
                placeholder="请选择"
                multiple
                collapse-tags
                :multiple-limit="itemObj.multipleLimit"
            >
                <el-option
                    v-for="item in itemObj.options"
                    :key="'mutl'+item.value"
                    :label="item.name"
                    :value="item.value"
                >
                </el-option>
            </el-select>
        </div>

         <!-- 数字文本框 -->
         <div v-else-if="nowType == 'measure'">
            <el-input 
                v-model="itemVal"
                @input="onInputFn"
                :disabled="itemObj.isDisabled"
                placeholder="请输入" 
                style="width: 240px;"
                type="number"
            >
            </el-input>
            <span style="color: #666;font-size:12px;line-height: 20px; margin-left:10px;">{{itemObj.property_id == 5588 ? '月':'天'}}</span>
        </div>
        
        <!-- 文本框 -->
        <div v-else-if="nowType == 'text'">
            <el-input 
                v-model="itemVal"
                @input="onInputFn"
                :disabled="itemObj.isDisabled"
                placeholder="请输入" 
                style="width: 240px;"
            >
            </el-input>
        </div>

    </el-form-item>
</template>

<script>
    export default {
        props: {
            itemObj: {
                type: Object,
                default: ()=>{
                    return {
                        label: '属性名',
                        itemType: 'multi_select', // 类型: text=字符串, select=单选, multi_select=多选
                        options: [{value: '11', name: '哈1'}, {value: '12', name: '哈2'}, {value: '13', name: '哈3'}],
                        multipleLimit: 0, // itemType为multi_select时，最多选择项目，0不限制
                        diy_type: 0
                    }
                }
            },
            value: {
                type: Array,
                default: ()=>{
                    return [{
                        "value": '',
                        "name": "",
                        "diy_type": 1
                    }]
                }
            }
        },
        computed: {
            nowType(){ // 当前表单项type
                let whiteArr = ['text', 'select', 'multi_select', 'measure']

                if(whiteArr.includes(this.itemObj.itemType)){
                    return this.itemObj.itemType
                }else{
                    return 'text'
                }
            }
        },
        watch: {
            value: {
                deep: true,
                immediate: true,
                handler(nval){
                    // console.log('value-nval:', this.itemObj)
                    if(Array.isArray(nval) && nval.length){
                        if(this.itemObj.itemType=='select'){ // 单选
                            this.itemVal = nval[0].name || nval[0].value
                        }
                        if(this.itemObj.itemType=='multi_select'){ // 多选
                            let arr = nval.map(item=>item.value)
                            this.itemVal = arr
                        }
                        if(this.itemObj.itemType=='text'){ // 文本框
                            this.itemVal = nval[0].name
                        }
                        if(this.itemObj.itemType=='measure'){ // 数字文本框
                            this.itemVal = Number(nval[0].name.replace(/[天月]$/, ''))
                        }
                    }
                }
            }
        },
        data(){
            return {
                itemVal: ''
            }
        },
        methods: {
            // 监听itemVal 改变
            onInputFn(e){
                let emitArr = []
                let { diy_type } = this.itemObj
                if(this.itemObj.itemType=='select'){ // 单选
                    let targetObj = this.itemObj.options.find(item => item.value == e)
                    emitArr = [{
                        value: e,
                        name: targetObj.name,
                        diy_type: diy_type
                    }]
                    
                }
                if(this.itemObj.itemType=='multi_select'){ // 多选
                    this.itemObj.options.forEach((item, index)=>{
                        if(e.includes(item.value)){
                            let obj = {
                                value: item.value,
                                name: item.name,
                                diy_type: diy_type
                            }
                            emitArr.push(obj)
                        }
                    })
                }
                if(this.itemObj.itemType=='text' ){ // 文本框
                    emitArr = [{
                        value: 0,
                        name: e,
                        diy_type: diy_type
                    }]
                }
                if( this.itemObj.itemType=='measure' ){ // 数字文本框
                    this.itemVal = e.replace(/[^\d]/g, '')
                    if(/[^\d]/g.test(e)){
                        return
                    }
                    emitArr = [{
                        value: 0,
                        name: e,
                        diy_type: diy_type
                    }]
                    // if (this.itemObj.property_id == 5588) {
                    //     emitArr = [{
                    //         value: 0,
                    //         name: `${e}月`,
                    //         diy_type: diy_type
                    //     }]
                    // } 
                    // if (this.itemObj.property_id == 5592) {
                    //     emitArr = [{
                    //         value: 0,
                    //         name: `${e}天`,
                    //         diy_type: diy_type
                    //     }]
                    // }
                   
                }
                this.$emit('input', emitArr)
                // console.log('emitArr:',emitArr)
            }
        }
    }
</script>

<style lang="less" scoped>

</style>
